// extracted by mini-css-extract-plugin
export var tabsWrapper = "w3S5MPiH64b4ZigOXaYI";
export var withScroll = "ePJxcxl6d1TAdcgoS9I2";